/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ReportFlowContainer_comment = {
    readonly id: string;
    readonly viewerActionPresence: {
        readonly dontAgree: boolean;
        readonly flag: boolean;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"ReportCommentFormContainer_comment">;
    readonly " $refType": "ReportFlowContainer_comment";
};
export type ReportFlowContainer_comment$data = ReportFlowContainer_comment;
export type ReportFlowContainer_comment$key = {
    readonly " $data"?: ReportFlowContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReportFlowContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReportFlowContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ActionPresence",
            "kind": "LinkedField",
            "name": "viewerActionPresence",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "dontAgree",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "flag",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ReportCommentFormContainer_comment"
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = '2fbff4ac5a57ab553f5cde3a7d05d877';
export default node;
